var _defs, _path, _path2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161,185c-36.9,19.2-82.4,4.7-101.6-32.2-19.2-36.9-4.7-82.4,32.2-101.6,7.9-4.1,16.3-6.7,24.7-7.8-2.9-.3-5.8-.4-8.7-.4-47.1,0-85.3,38.2-85.3,85.4s38.2,85.4,85.3,85.4,62.2-19.2,76.3-47.1c-6.2,7.3-13.8,13.6-22.9,18.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.3,38.8c38.2-16.6,82.5,1,99.1,39.1,16.6,38.2-1,82.5-39.1,99.1-8.2,3.6-16.7,5.5-25.2,6.1,2.8.5,5.7.8,8.7,1,47,3.3,87.8-32.3,91.1-79.3,3.3-47.1-32.2-87.9-79.2-91.1-33.3-2.3-63.4,14.8-79.4,41.7,6.7-6.9,14.8-12.6,24.1-16.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "123.5 48 97.9 106 113.6 111.5 104.1 174.3 130.1 111.7 114.2 106.9 123.5 48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.e7050ffe9c62864cfde819e644ada41c.svg";
export { ForwardRef as ReactComponent };